import { ApiError } from "@/api/client";
import { clearSession, goToSignIn, setCurrentTenant } from "./session";

const NO_ACCESS = new Set(["no_account", "no_tenant", "suspended", "removed"]);

/**
 * What to do when the API refuses: sign in again, fall back to another tenant, or explain on
 * the no-access screen. Returns true when it handled the error.
 */
export function handleAccessError(error: unknown): boolean {
  if (!(error instanceof ApiError)) return false;
  if (error.status === 401) {
    clearSession();
    goToSignIn();
    return true;
  }
  if (error.status !== 403) return false;
  const code = error.code;
  if (code === "not_member") {
    // The tenant this browser remembered no longer has them; the API picks their first.
    setCurrentTenant(null);
    window.location.assign("/");
    return true;
  }
  if (code && NO_ACCESS.has(code)) {
    if (!window.location.pathname.startsWith("/no-access")) {
      window.location.assign(`/no-access?code=${code}`);
    }
    return true;
  }
  return false;
}
